import { RouterProvider } from 'react-router-dom';
import { router } from './router';

/**
 * Raiz de la aplicacion. Hoy solo monta el router: no hay estado global, no hay
 * backend y la venta vive fuera (Hi.Events). Si algun dia hace falta un
 * proveedor de contexto, entra aqui y en ningun otro sitio.
 */
export function App() {
  return <RouterProvider router={router} />;
}
